/* eslint-disable camelcase */
import { API_STATUS } from 'core-lib/constants/network';
import ip from 'icepick';
import { ReducerType } from '../types/store';
import {
  GET_EXPLORE_MARKETPLACE,
  GET_FEEDBACK_DATA,
  GET_HISTORY,
  GET_RECOMMENDED,
  GET_WISHLIST,
  UPDATE_BRAND_LIST,
  UPDATE_CITY_LIST,
  UPDATE_COORDINATES,
  // UPDATE_LOCATION,
  UPDATE_MAPPED_LOCATION,
  UPDATE_NEARYBY_CITIES,
  UPDATE_SIMILAR_BY_PRICE,
} from './type';

const initialState: ReducerType = ip.freeze({
  feedbackData: {
    apiStatus: API_STATUS.default,
    data: null,
  },
  exploreMarketPlace: {
    data: null,
    apiStatus: API_STATUS.default,
  },
  wishList: {
    apiStatus: API_STATUS.default,
    list: null,
    count: 0,
    currentPage: 0,
    hasMore: true,
  },
  history: {
    apiStatus: API_STATUS.default,
    data: null,
  },
  recommended: {
    apiStatus: API_STATUS.default,
    data: null,
  },
  cityList: {
    apiStatus: API_STATUS.default,
    list: null,
  },
  similarCarsByPrice: {
    inventoryId: null,
    apiStatus: API_STATUS.default,
    data: null,
  },
  brandList:{
    apiStatus:API_STATUS.default,
    data:null
  },
  mappedLocations:{},
  nearbyCities:[],
});

export function usedCarReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_MAPPED_LOCATION: {
      state = ip.setIn(state, ['mappedLocations'], action.payload);
      return state;
    }
    case UPDATE_COORDINATES: {
        state = ip.setIn(state, ['coordinates'], action.payload);
        return state;
      }
    case GET_FEEDBACK_DATA: {
      state = ip.setIn(state, ['feedbackData'], action.payload);
      return state;
    }
    case GET_WISHLIST: {
      state = ip.setIn(state, ['wishList'], action.payload);
      return state;
    }
    case GET_HISTORY: {
      state = ip.setIn(state, ['history'], action.payload);
      return state;
    }
    case GET_RECOMMENDED: {
      state = ip.setIn(state, ['recommended'], action.payload);
      return state;
    }
    case GET_EXPLORE_MARKETPLACE: {
      state = ip.setIn(state, ['exploreMarketPlace'], action.payload);
      return state;
    }
    case UPDATE_SIMILAR_BY_PRICE: {
      state = ip.setIn(state, ['similarCarsByPrice'], action.payload);
      return state;
    }
    // case UPDATE_LOCATION: {
    //   state = ip.setIn(state, ['location'], action.payload);
    //   return state;
    // }
    case UPDATE_CITY_LIST: {
      state = ip.setIn(state, ['cityList'], action.payload);
      return state;
    }
    case UPDATE_BRAND_LIST:{
      state = ip.setIn(state,['brandList'],action.payload);
      return state;
    }
    case UPDATE_NEARYBY_CITIES:{
      state = ip.setIn(state,['nearbyCities'],action.payload);
      return state;
    }
    default:
      return state;
  }
}

export default usedCarReducer;
